<template>
  <div class="title-item-container">
    <div class="blue-box"></div>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.title-item-container {
  display: flex;
  align-items: center;
  .blue-box {
    width: 5px;
    height: 20px;
    background-color: #409eff;
  }
  h3 {
    margin-left: 15px;
  }
}
</style>
